import React from "react";
import { Table } from "react-bootstrap";

import "../components/css/LatestTrans.css";

const ProductsPerTable = ({ productRanking, isLoading }) => {
    const dualPaymentItem = productRanking.find(item =>
        item.paymentTypes?.includes("iPay88") && item.paymentTypes?.includes("mro")
    );

    const fallbackPaymentItem = productRanking.find(item =>
        item.paymentTypes || item.Mode
    );

    const currentPaymentType = dualPaymentItem?.paymentTypes ||
        fallbackPaymentItem?.paymentTypes ||
        fallbackPaymentItem?.Mode ||
        "";
        
    const salesLabel = currentPaymentType.includes(", ")
        ? "Amount"
        : currentPaymentType.includes("commercial")
        ? "Sales"
        : currentPaymentType.includes("mro")
        ? "Credit"
        : "Amount";
    
    const getSalesOrCredits = (item) => {
        const mode = item.Mode;
        const paymentTypes = item.paymentTypes;

        if ((!paymentTypes || paymentTypes.trim() === "") && mode === "commercial") {
            return `Sales: ${item.totalSales}`;
        }

        if (mode === "mro") {
            if (paymentTypes?.includes("mro") && paymentTypes?.includes("iPay88")) {
                return `Sales: ${item.sales} | Credits: ${item.credits}`;
            } else if (paymentTypes?.includes("mro") || paymentTypes === null) {
                return `Credits: ${item.totalSales}`;
            } else {
                return `Sales: ${item.totalSales}`;
            }
        } else if (mode === "commercial") {
            return `Sales: ${item.totalSales}`;
        }
    };

    return(
        <>
            <div className="proTableDiv">
                <h6 className="lblProductTable">Product Ranking</h6>

                <Table striped bordered hover responsive size="sm">
                    <thead>
                        <tr>
                            <th>Product Name</th>
                            <th>Frequency</th>
                            <th>{salesLabel}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr>
                                <td colSpan="4" style={{ textAlign: "center", padding: "10px", fontStyle: "italic", fontWeight: "bold" }}>
                                    Loading...
                                </td>
                            </tr>
                        ) : productRanking.length > 0 ? (
                            productRanking.map((row) => (
                                <tr key={row.productId}>
                                    <td className="fontHandle">{row.productName || "N/A"}</td>
                                    <td className="fontHandle">{row.frequency || "0"}</td>
                                    <td className="fontHandle">
                                        {getSalesOrCredits(row)}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" style={{ textAlign: "center", padding: "10px", fontStyle: "italic" }}>
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </>
    );
};

export default ProductsPerTable;